import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-purple-900/20 to-black flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-gray-900 rounded-lg p-8 border border-gray-700 shadow-xl text-center">
          <div className="w-20 h-20 bg-gray-700/30 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-12 h-12 text-gray-400" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-2">
            Payment Cancelled
          </h1>
          
          <p className="text-gray-400 mb-6">
            Your payment was cancelled. No charges were made to your account.
          </p>

          <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-300">
              💡 You can try again anytime. We're here to help if you have questions!
            </p>
          </div>

          <div className="space-y-3">
            <Button
              onClick={() => navigate('/subscribe')}
              className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold py-3"
            >
              View Plans Again
            </Button>
            <Button
              onClick={() => navigate('/browse')}
              variant="outline"
              className="w-full border-gray-600 text-gray-300 hover:bg-gray-800"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Browse
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
